import { atom } from "recoil";
import { FindAllContactWithFilterIRoute } from "../api/Contacts";
import { ContactStatus } from "../types/Contact";

export type IContactFiltersAtom = Omit<
  FindAllContactWithFilterIRoute,
  "limit | offset"
>;

export const ContactFiltersAtom = atom<IContactFiltersAtom>({
  key: "ContactFiltersAtom",
  default: {
    status: [
      ContactStatus.CONFIRMED,
      ContactStatus.NOT_CONFIRMED,
      ContactStatus.ADMIN_UNSUBSCRIBED,
      ContactStatus.UNSUBSCRIBED,
      ContactStatus.SUPRESSED,
      ContactStatus.SPAM,
      ContactStatus.BOT_FILLED,
      ContactStatus.BLOCKED,
      ContactStatus.PENDING_CONFIRMATION,
    ],
    createdAt: -1,
  },
});

export const ContactSearchOnCampaignAtom = atom<string>({
  key: "ContactSearchOnCampaignAtom",
  default: "",
});
